import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Paper,
  Typography,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import {
  cardOutline,
  getStartedSmallButtons,
  headingFonts,
} from "../Styles/Styles";
import LoadingAnimation from "./Animations/LoadingAnimation";

export default function EmailVerification() {
  const { token } = useParams(); // Get the token from the URL
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasFetched, setHasFetched] = useState(false); // Add a state to track if the fetch has occurred
  const navigate = useNavigate(); // To redirect the user after verification

  useEffect(() => {
    // Only call the API if it hasn't been fetched already
    if (!hasFetched) {
      const verifyEmail = async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_SERVER_BASE_URL}/user/verify-email/${token}`
          );
          console.log(response);
          if (!response.ok) {
            throw new Error(
              "Email verification failed. Invalid or expired token."
            );
          }

          const data = await response.json();
          setVerificationStatus(data.message); // Set the success message
        } catch (error) {
          setError(error.message); // Set the error message
        } finally {
          setLoading(false); // Stop loading spinner
          setHasFetched(true); // Mark that the fetch has been completed
        }
      };

      verifyEmail(); // Call the function on component mount
    }
  }, [token, hasFetched]);

  // Handle loading state

  // Display the verification result
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        p: 3,
      }}
    >
      <Helmet>
        <title>Email Verification - Listed.ky</title>
        <meta name="description" content="Email Verification - Listed.ky" />
      </Helmet>

      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 450,
          textAlign: "center",
          borderRadius: 2,
          ...cardOutline,
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ ...headingFonts }}>
          Email Verification
        </Typography>

        {loading && <LoadingAnimation />}

        {error ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        ) : (
          <Alert severity="success" sx={{ mt: 2 }}>
            {verificationStatus}
            <br />
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate("/get-started")}
              sx={{ ...getStartedSmallButtons }}
            >
              LOG IN
            </Button>
          </Alert>
        )}
      </Paper>
    </Box>
  );
}
